import React, { useState } from 'react';
import api from '../utils/Api';
import { api_url } from '../utils/Config';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { clearAuthData } from '../redux/AuthSlice';
import { Oval } from 'react-loader-spinner';

const Header = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { token,email } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Mock user data - replace with actual user data from your state management
  const user = {
    name: 'Admin',
    email,
    avatar: `https://ui-avatars.com/api/?name=${email}&background=random`
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`${api_url}/logout`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch(clearAuthData());

      window.history.pushState(null, '', '/');
      window.onpopstate = () => {
        window.history.pushState(null, '', '/');
      };

      toast.success('Logout successful', {
        icon: "🚀"
      });

      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className="bg-white shadow-sm h-16 flex items-center justify-between px-6 relative">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-semibold"></h1>
      </div>

      <div className="flex items-center gap-4">
        {/* Notifications Bell */}
        <button className="p-2 hover:bg-gray-100 rounded-full">
          <svg
            className="w-6 h-6 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>

        {/* Profile Dropdown */}
        <div className="relative">
          <button
            onClick={() => setIsProfileOpen(!isProfileOpen)}
            className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded-lg"
          >
            <img
              src={user.avatar}
              alt="Profile"
              className="w-8 h-8 rounded-full"
            />
            <span className="text-sm font-medium text-gray-700">{user.name}</span>
            <svg
              className={`w-4 h-4 text-gray-600 transition-transform ${isProfileOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Dropdown Menu */}
          {isProfileOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-10 border border-gray-200">
              <div className="px-4 py-2 border-b border-gray-200">
                <p className="text-sm font-medium text-gray-900">{user.name}</p>
                <p className="text-sm text-gray-500">{user.email}</p>
              </div>

              <nav className="py-1">
                <a
                  href="/dashboard/profile"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                >
                  Your Profile
                </a>
                {/* <a
                  href="/settings"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                >
                  Settings
                </a> */}
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                >
                  {loading ? (
                    <div className=" flex justify-center items-center">
                      <Oval
                        visible={true}
                        height="20"
                        width="20"
                        color="#ffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  ) : 'Sign out'}
                </button>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;